import { Environment } from "types";

export default {
  [Environment.STAGING]: {
    subdomain: "staging",
    domain: "mmerch.com"
  },
  [Environment.PRODUCTION]: {
    subdomain: "www",
    domain: "mmerch.com"
  },
  [Environment.DEVELOPMENT]: {
    subdomain: "localhost:3000"
  }
};
